export const data =
{
    scene: '02_epilogi',
    teksti: 'Huh, kuumottavat lääkehommat on saatu päätökseen. Seuraavaksi Pentille pitäisi opettaa apuvälineiden käyttöä tulevaa lonkan keinonivelleikkausta silmällä pitäen '





};



